'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AccessibleTextArea = require('./components/AccessibleTextArea.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccessibleTextArea).default;
  }
});
Object.defineProperty(exports, 'AccessibleTextArea', {
  enumerable: true,
  get: function get() {
    return _AccessibleTextArea.AccessibleTextArea;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-text-area/lib/index.js
// module id = 117
// module chunks = 1